export default function use(...plugins) {
  plugins.forEach(p => {
    p({
      proto: this,
      blcktive: this.constructor.blcktive,
      instance: this
    });
  });
  return this;
}
